import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children, platformOnly, tenantOnly }) {
  const { auth } = useAuth();
  if (auth === null)
    return (
      <div className="h-screen grid place-items-center bg-slate-50">
        <Loader2 className="h-6 w-6 animate-spin text-blue-600" />
      </div>
    );
  if (auth === false) return <Navigate to="/login" replace />;
  if (platformOnly && !auth.is_platform_admin) return <Navigate to="/app" replace />;
  if (tenantOnly && auth.is_platform_admin) return <Navigate to="/platform" replace />;
  return children;
}
